import { accountingApi } from '../../../../config/apiClient';
import { ACCOUNTING_API } from '../../../../config/api';

export type ActiveCurrencyOption = { code: string; active: boolean };

/**
 * Şirketin aktif para birimleri (SADECE SQL — döviz ayarları, GET /api/Currency/settings).
 * accountingApi isteklerinde X-Company-Id header zaten apiClient ile eklenir.
 * Faz B: eski Firebase yedek okuma kaldırıldı.
 */
export async function loadCompanyActiveCurrencies(_companyId: string): Promise<ActiveCurrencyOption[]> {
  try {
    const response = await accountingApi.get(ACCOUNTING_API.CURRENCY_SETTINGS);
    const result = response.data as { success?: boolean; data?: Record<string, boolean> };
    if (result?.success && result.data && typeof result.data === 'object' && !Array.isArray(result.data)) {
      const settings = result.data;
      const currencies: ActiveCurrencyOption[] = [{ code: 'TRY', active: true }];
      Object.entries(settings).forEach(([code, isActive]) => {
        if (code !== 'TRY' && isActive === true) currencies.push({ code, active: true });
      });
      return currencies;
    }
  } catch (e) {
    console.error('[loadCompanyActiveCurrencies] SQL döviz ayarları okunamadı:', e);
  }

  return [{ code: 'TRY', active: true }];
}
